/**
 * Share & Earn (Dropshipping Income) link builders — the ONE place these URLs
 * are composed. `shareRef` is a slot's share ref from `GET /me/slots/share-links`
 * (custom referral code or raw slot code, possibly an encrypted `e1.` token) —
 * always percent-encoded here, never pre-encoded by the caller.
 *
 * Distinct from the RECRUITING link builders (`resolveRpLink` in
 * replicated-sections.ts): these attribute an ORDER's margin to the sharer;
 * those attribute a PERSON's sponsorship at signup.
 */

/** Per-product Share & Earn link — lands on the product page with the ref. */
export function productShareLink(origin: string, productId: string, shareRef: string): string {
  return `${origin}/product/${productId}?ref=${encodeURIComponent(shareRef)}`;
}

/**
 * Store-wide Share & Earn link — `/s/:ref` stores the ref then drops the lead
 * on the storefront; everything they buy in that visit is attributed like a
 * per-product share. Gated by the `store_wide_dropship_link` tenant flag
 * (member SPA route ignores the ref when the flag is off).
 */
export function storeShareLink(origin: string, shareRef: string): string {
  return `${origin}/s/${encodeURIComponent(shareRef)}`;
}
